// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-49dd656a]{color:var(--color-black);font-size:var(--font-size-small);font-weight:500}.icon[data-v-49dd656a]{color:var(--color-darker-grey);font-size:var(--font-size-eleven)}.flexWrap[data-v-49dd656a]{position:relative;width:100%;display:flex;justify-content:space-between;align-items:center}.navBaseElem.logout[data-v-49dd656a]{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
